// parsers
import {
  parseProductYears
} from 'settings/productYearsParser';

// action creators
import {
  setProductYears
} from 'settings';

export const processProductYears = ({ dispatch, rawSeasonCodes }) => {
  const productYears = parseProductYears(rawSeasonCodes);

  dispatch(setProductYears(productYears));
  return Promise.resolve(productYears);
};
